import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuestionComponent } from './question.component';
import { QuestionTagsModule, QuestionTextModule, QuestionConditionsModule, QuestionFilterModule  } from '../../../../shared';
import { RepliesPerOptionModule } from '../../../modals/replies-per-option/replies-per-option.module';


@NgModule({
  imports: [
    RepliesPerOptionModule,
  ],
  declarations: [QuestionComponent],
  exports:[
    CommonModule, 
    QuestionTagsModule,
    QuestionConditionsModule,
    QuestionTextModule,
    RepliesPerOptionModule,
    QuestionFilterModule,
  ],

})
export class QuestionModule { }
